import { render, staticRenderFns } from "./NewsRow.vue?vue&type=template&id=4faac78c&scoped=true&"
import script from "./NewsRow.vue?vue&type=script&lang=js&"
export * from "./NewsRow.vue?vue&type=script&lang=js&"
import style0 from "./NewsRow.vue?vue&type=style&index=0&id=4faac78c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faac78c",
  null
  
)

export default component.exports